// src/hooks/useAnalytics.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom"; // or next/router if Next.js
import { trackEvent } from "app/utils/analyticsHelper";

export const useAnalytics = () => {
  const location = useLocation();

  // Track page views automatically
  useEffect(() => {
    trackEvent("page_view", { path: location.pathname });
  }, [location]);

  // Return a helper function for tracking custom events
  const track = (eventName: string, eventParams: Record<string, any> = {}) => {
    trackEvent(eventName, eventParams);
  };

  return { track };
};
